module.exports = __webpack_public_path__ + "img/united3-cover-3.d30b946f.jpg";